import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=504d6932"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"
import style0 from "./Landing.vue?vue&type=style&index=0&id=504d6932&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('504d6932')) {
      api.createRecord('504d6932', component.options)
    } else {
      api.reload('504d6932', component.options)
    }
    module.hot.accept("./Landing.vue?vue&type=template&id=504d6932", function () {
      api.rerender('504d6932', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Study/Landing.vue"
export default component.exports